import React from 'react'
import { useOptionalEinsatz } from './EinsatzContext'
import { oeffneEinsatzWahl } from './EinsatzWahl'

/**
 * Gelber Hinweis (Slot `banner` der AppShell, neben der StaleBanner), wenn der gewählte Einsatz beendet wurde
 * oder nicht (mehr) wählbar ist. Die Wahl ist dann leer; es erfolgt KEIN automatischer Sprung zu einem anderen Einsatz.
 */
export function EinsatzHinweis({ className }: { className?: string }) {
  const ew = useOptionalEinsatz()
  if (!ew?.hinweis) return null
  const h = ew.hinweis
  const text = h.art === 'beendet'
    ? `Einsatz „${h.titel}“ wurde beendet. Es ist kein Einsatz gewählt.`
    : `Einsatz „${h.titel}“ ist nicht (mehr) verfügbar. Es ist kein Einsatz gewählt.`
  return (
    <div className={`ui-banner ui-banner--warn ${className ?? ''}`} role="status">
      <span className="ui-banner-txt">{text}</span>
      {!ew.locked && <button type="button" className="ui-banner-btn" onClick={oeffneEinsatzWahl}>Anderen Einsatz wählen</button>}
      <button type="button" className="ui-banner-btn" onClick={ew.dismissHinweis}>Schließen</button>
    </div>
  )
}
